import { useState } from "react";
import { toast } from "sonner";
import { PaperPlaneRight } from "@phosphor-icons/react";
import api, { formatApiErrorDetail } from "../../../lib/api";

export function AiFollowup({ suggestion, onUpdate }) {
  const [q, setQ] = useState("");
  const [busy, setBusy] = useState(false);
  const items = suggestion.followups || [];
  const left = suggestion.followups_left ?? 0;
  const ask = async () => {
    if (!q.trim() || busy) return;
    setBusy(true);
    try {
      const { data } = await api.post(`/ai-suggestions/${suggestion.id}/followup`, { question: q.trim() });
      onUpdate({ followups: [...items, data.followup], followups_left: data.followups_left });
      setQ("");
    } catch (e) {
      toast.error(formatApiErrorDetail(e?.response?.data?.detail) || "Could not send your question");
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="card-flat p-4 space-y-2" data-testid="ai-followup">
      <div className="eyebrow text-[9px]">Ask a follow-up · {left} left</div>
      {items.map((f, i) => (
        <div key={f.at || i} className="text-xs space-y-1" data-testid={`ai-followup-item-${i}`}>
          <div className="font-semibold">You: {f.q}</div>
          <div className="text-muted-foreground whitespace-pre-wrap" data-testid={`ai-followup-answer-${i}`}>{f.a}</div>
        </div>
      ))}
      {left > 0 ? (
        <div className="flex gap-2">
          <input value={q} onChange={(e) => setQ(e.target.value)} maxLength={500} onKeyDown={(e) => e.key === "Enter" && ask()}
                 placeholder="e.g. Should I prepay the Car loan instead?" className="input-dark flex-1 px-2 py-1.5 text-xs" data-testid="ai-followup-input" />
          <button type="button" onClick={ask} disabled={busy || !q.trim()} className="btn-primary px-3 py-1.5 text-xs inline-flex items-center gap-1 disabled:opacity-40" data-testid="ai-followup-send">
            <PaperPlaneRight size={12} /> {busy ? "…" : "Ask"}
          </button>
        </div>
      ) : (
        <div className="text-[11px] text-muted-foreground">Follow-up limit reached for this suggestion.</div>
      )}
    </div>
  );
}
